'use client'

import { Fragment } from 'react'
import { Marquee } from '@/lib/ui-kit/components/ui/Marquee.component'
import {
  ComponentReeveCarouselText,
  ComponentReeveCarouselIcon,
} from '@/lib/api-connector-strapi-cms/api/reeve-landing-page/reeveLandingPageApi.types'
import Image from 'next/image'

interface CarouselProps {
  cards: (ComponentReeveCarouselIcon | ComponentReeveCarouselText)[]
  apiAssetsUrl?: string
}

const iconBackgroundColors = {
  yellow: 'hover:bg-reeve-yellow',
  green: 'hover:bg-reeve-green',
  blue: 'hover:bg-reeve-blue',
  purple: 'hover:bg-reeve-purple',
  orange: 'hover:bg-reeve-orange',
}

const iconShape = {
  square: 'rounded-md',
  circle: 'rounded-full',
}

export const Carousel = ({ cards, apiAssetsUrl }: CarouselProps) => {
  return (
    <Marquee direction="left" pauseOnHover numberOfCopies={5}>
      {cards.map((card, index) => (
        <Fragment key={index}>
          {card.__typename === 'ComponentReeveCarouselText' && (
            <div
              className={`${
                iconBackgroundColors[card.textColor]
              } flex-shrink-0 select-none rounded-md bg-reeve-gray px-2 py-1 text-center text-[1.5rem] font-normal leading-[150%] text-reeve-secondary-gray transition-colors duration-150 ease-in-out hover:text-reeve-primary`}
            >
              <span>{card.text}</span>
            </div>
          )}
          {card.__typename === 'ComponentReeveCarouselIcon' && (
            <div
              className={`${iconBackgroundColors[card.iconColor]} ${
                iconShape[card.shape]
              } flex-shrink-0 select-none bg-reeve-gray p-1 text-center text-[1.5rem] font-normal leading-[150%] text-reeve-secondary-gray transition-colors duration-150 ease-in-out hover:text-reeve-primary`}
            >
              <div
                className="bg-reeve-secondary-gray transition-colors duration-150 ease-in-out hover:bg-reeve-primary"
                style={{
                  width: '2.25rem',
                  height: '2.25rem',
                  maskImage: `url(${apiAssetsUrl || ''}${card.icon.url})`,
                  WebkitMaskImage: `url(${apiAssetsUrl || ''}${card.icon.url})`,
                  maskRepeat: 'no-repeat',
                  WebkitMaskRepeat: 'no-repeat',
                  maskSize: 'contain',
                  WebkitMaskSize: 'contain',
                  maskPosition: 'center',
                  WebkitMaskPosition: 'center',
                }}
              />
            </div>
          )}
        </Fragment>
      ))}
    </Marquee>
  )
}
